<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartdata", "title"],
  data() {
    return {
      optionss: {
        title: {
          display: false,
          text: "",
          fontSize: 20
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Serial position"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Correctly recalled"
              },
              ticks: {
                suggestedMax: 100,
                suggestedMin: 0
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.optionss.title.text = this.title;
    this.renderChart(this.chartData, this.getOption);
  },
  computed: {
    getOption: function() {
      let op = this.optionss;
      op.title.text = this.title;
      return op;
    }
  },
  watch: {
    chartData() {
      this.optionss.title.text = this.title;
      this.$data._chart.update();
    }
  }
};
</script>